module.exports = __webpack_public_path__ + "img/figure-2.c0f5bfd4.png";